import { capitalDesignTokens } from "@opengov/capital-design-tokens";
const MuiDataGrid = {
  defaultProps: {
    rowHeight: capitalDesignTokens.componentSizes.xLarge,
    columnHeaderHeight: capitalDesignTokens.componentSizes.xLarge
  },
  styleOverrides: {
    root: ({ theme }) => ({
      "--DataGrid-containerBackground": theme.palette.background.default,
      border: "1px solid",
      borderColor: theme.palette.divider,
      borderRadius: "4px",
      ".MuiDataGrid-row": {
        backgroundColor: theme.palette.background.paper,
        "&:hover": {
          backgroundColor: theme.palette.action.hover
        }
      },
      ".MuiDataGrid-menuIcon": {
        ".MuiSvgIcon-root": {
          fontFamily: capitalDesignTokens.foundations.typography.baseFont,
          fontSize: "16px",
          color: theme.palette.text.disabled
        }
      },
      ".MuiDataGrid-sortIcon": {
        fontFamily: capitalDesignTokens.foundations.typography.baseFont,
        fontSize: "16px",
        color: theme.palette.text.disabled
      },
      ".MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderDraggableContainer": {
        justifyContent: "flex-end"
      },
      ".MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer": {
        justifyContent: "flex-end",
        flexDirection: "row"
      },
      ".MuiDataGrid-columnHeader--alignRight .MuiDataGrid-menuIcon": {
        margin: 0
      },
      ".MuiDataGrid-cell, .MuiDataGrid-columnHeader": {
        paddingLeft: "16px",
        paddingRight: "16px"
      }
    })
  }
};
export {
  MuiDataGrid
};
//# sourceMappingURL=MuiDataGrid.js.map
